import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useAuth } from '../../providers/auth_provider'
import { Link } from 'react-router-dom';
import Overview from './overview';
import Security from './security';
import { formatDate } from '../../utils/format_date';

export default function Profile() {
    const { adminData } = useAuth();
    const [component, setComponent] = useState('overview');
    return (
        <>
            <Helmet>
                <title>Profile - Enervybe</title>
            </Helmet>
            {/* Header */}
            <div className="row">
                <div className="col-12">
                    <div className="card mb-6">
                        <div className="user-profile-header-banner">
                            <img src="/assets/img/pages/profile-banner.png" alt="Banner image" className="rounded-top" />
                        </div>
                        <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-5">
                            <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                                <img src={adminData?.profile_img ? adminData?.profile_img : '/assets/img/avatars/1.png'} alt="user image" className="d-block h-auto ms-0 ms-sm-5 rounded-4 user-profile-img" />
                            </div>
                            <div className="flex-grow-1 mt-4 mt-sm-12">
                                <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-5 flex-md-row flex-column gap-6">
                                    <div className="user-profile-info">
                                        <h4 className="mb-2">{adminData?.first_name + ' ' + adminData?.last_name || ''}</h4>
                                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-4">
                                            <li className="list-inline-item">
                                                <i className="ri-admin-line me-2 ri-24px" />
                                                <span className="fw-medium">{adminData?.role?.name}</span>
                                            </li>
                                            <li className="list-inline-item">
                                                <i className="ri-calendar-line me-2 ri-24px" />
                                                <span className="fw-medium">Joined {formatDate(adminData?.created_at)}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    {adminData?.role?.permissions?.profile?.update_account &&
                                        <Link to='/profile/update' className="btn btn-label-primary">
                                            <i className="ri-pencil-line ri-16px me-2" />
                                            Edit
                                        </Link>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*/ Header */}

            <div className="row">
                <div className="col-md-12">
                    <div className="nav-align-top">
                        <ul className="nav nav-pills flex-column flex-sm-row mb-6 row-gap-2">
                            {adminData?.role?.permissions?.profile?.overview &&
                                <li className="nav-item">
                                    <button className={`nav-link ${component === 'overview' && 'active'}`} onClick={() => setComponent('overview')}>
                                        <i className="ri-user-3-line me-2" />
                                        Overview
                                    </button>
                                </li>
                            }
                            {adminData?.role?.permissions?.profile?.security &&
                                <li className="nav-item">
                                    <button className={`nav-link ${component === 'security' && 'active'}`} onClick={() => setComponent('security')}>
                                        <i className="ri-lock-2-line me-2" />
                                        Security
                                    </button>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>

            {component === 'overview' && <Overview />}
            {component === 'security' && <Security />}
        </>
    )
}
